module.exports = __webpack_public_path__ + "img/alfred.5fd6285f.svg";